export default {
  title: 'Impressum',
  subtitle: 'Customise the details shown in your storefront Impressum without touching your business profile.',
  defaultsNotice:
    'Every field is optional. Leave one empty to keep using the value from your business profile — the current default is shown in grey as a preview. Filling a field in overrides only the Impressum; your business profile stays unchanged.',
  fields: {
    legal_name: {
      label: 'Company / legal name',
      placeholder: 'e.g. Musterbetrieb GmbH',
    },
    owner_first_name: {
      label: 'Owner first name',
      placeholder: 'e.g. Alex',
    },
    owner_last_name: {
      label: 'Owner last name',
      placeholder: 'e.g. Müller',
    },
    owner_email: {
      label: 'Email',
      placeholder: 'e.g. info@example.com',
      invalid: 'Please enter a valid email address',
    },
    owner_phone_number: {
      label: 'Phone',
      placeholder: 'e.g. +49 30 1234567',
    },
    tax_id: {
      label: 'Tax ID',
      placeholder: 'e.g. DE123456789',
    },
    address: {
      label: 'Address',
      placeholder: 'Street, postal code, city',
    },
  },
  buttons: {
    save: 'Save',
  },
  toasts: {
    saved: 'Impressum saved',
    failed: 'Failed to save Impressum',
  },
};
